(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-main-product"] && !Shopify.designMode) return;
  try {
    
  const SECTION_SELECTOR = '.shopify-section--lp-main-product';

  const formatMoney = (dollars) => {
    const cents = Math.round(Number(dollars) * 100);
    const settings = window.themeVariables?.settings || {};
    const defaultMoneyFormat = '{' + '{amount' + '}}';
    const moneyFormat = settings.moneyFormat || defaultMoneyFormat;
    const placeholderRegex = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');

    const formatWithDelimiters = (num, prec = 2, thou = ',', dec = '.') => {
      if (isNaN(num) || num == null) return '0';

      num = (num / 100).toFixed(prec);
      const [dollarsPart, centsPart] = num.split('.');
      const formattedDollars = dollarsPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thou}`);
      let result = formattedDollars + (centsPart ? dec + centsPart : '');

      if (prec > 0) {
        result = result.replace(/0+$/, '').replace(/[.,]$/, '');
      }

      return result;
    };

    const type = (moneyFormat.match(placeholderRegex) || [])[1];
    const values = {
      amount: () => formatWithDelimiters(cents, 2),
      amount_no_decimals: () => formatWithDelimiters(cents, 2),
      amount_with_space_separator: () => formatWithDelimiters(cents, 2, ' ', '.'),
      amount_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
      amount_with_apostrophe_separator: () => formatWithDelimiters(cents, 2, "'", '.'),
      amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_space_separator: () => formatWithDelimiters(cents, 2, ' '),
      amount_no_decimals_with_apostrophe_separator: () => formatWithDelimiters(cents, 2, "'"),
    };

    const formattedValue = values[type] ? values[type]() : formatWithDelimiters(cents, 2);
    let formattedPrice = moneyFormat.replace(placeholderRegex, formattedValue);

    const currencyCode = settings.currencyCode || 'USD';
    const currencySymbol = settings.currencySymbol || '$';
    const isUSMarket = currencyCode === 'USD';
    const moneyFormatStripped = moneyFormat.replace(placeholderRegex, '').trim();
    const hasCurrencySymbol =
      /[\$€£¥₹]/.test(formattedPrice) || moneyFormatStripped.length > 0;

    if (!hasCurrencySymbol && !isUSMarket) {
      formattedPrice = `${currencySymbol}${formattedPrice} ${currencyCode}`;
    } else if (!hasCurrencySymbol && isUSMarket) {
      formattedPrice = `${currencySymbol}${formattedPrice}`;
    }

    return formattedPrice;
  };

  const getSellingPlanId = (subscriptionEl) => {
    const defaultPlanInput = subscriptionEl.querySelector('.js-default-selling-plan');
    if (defaultPlanInput?.value) return defaultPlanInput.value;

    const checkedPlan = subscriptionEl.querySelector('input[name="selling_plan"]:checked');
    if (checkedPlan?.value) return checkedPlan.value;

    return subscriptionEl.dataset.defaultSellingPlan || '';
  };

  const resolveCompareAtCents = (subscriptionEl, saleCents, variantCompareCents = 0) => {
    const datasetCompareCents = parseInt(subscriptionEl.dataset.compareAtPriceCents || '0', 10);
    const productCompareCents = Math.round(Number(subscriptionEl.dataset.compareAtPrice || 0) * 100);
    const candidates = [variantCompareCents, datasetCompareCents, productCompareCents].filter(
      (cents) => cents > 0
    );
    const higherThanSale = candidates.filter((cents) => cents > saleCents);

    if (higherThanSale.length) {
      return Math.max(...higherThanSale);
    }

    return candidates.length ? Math.max(...candidates) : saleCents;
  };

  const syncVariantPriceDataset = (subscriptionEl, form) => {
    const variantInput =
      subscriptionEl.querySelector('.js-variant-quantity-selector:checked') ||
      form.querySelector('input[name="id"]:checked') ||
      form.querySelector('input[name="id"]');

    if (!variantInput?.value) return;

    const label = variantInput.closest('label[data-variant-price]');
    let otpCents = 0;
    let variantCompareCents = 0;
    let variant = null;

    if (label) {
      otpCents = parseInt(label.dataset.variantPrice, 10) || 0;
      variantCompareCents = parseInt(label.dataset.variantComparePrice, 10) || 0;
    }

    if (form.dataset.variants) {
      const variants = JSON.parse(form.dataset.variants);
      variant = variants.find((item) => item.id === parseInt(variantInput.value, 10));
    }

    if (variant) {
      otpCents = otpCents || variant.price;
      variantCompareCents = variantCompareCents || variant.compare_at_price || 0;
    }

    if (!otpCents) return;

    let subCents = parseInt(subscriptionEl.dataset.subscriptionPriceCents || '0', 10);
    const planId = getSellingPlanId(subscriptionEl);

    if (variant?.selling_plan_allocations?.length) {
      const allocation = variant.selling_plan_allocations.find(
        (item) => String(item.selling_plan_id) === String(planId)
      );

      if (allocation?.price) {
        subCents = allocation.price;
      }
    }

    if (!subCents) {
      subCents =
        subscriptionEl.dataset.productType === 'system'
          ? Math.round(otpCents * 0.75)
          : Math.round(otpCents * 0.7);
    }

    const compareAtCents = resolveCompareAtCents(subscriptionEl, otpCents, variantCompareCents);

    subscriptionEl.dataset.oneTimePriceCents = String(otpCents);
    subscriptionEl.dataset.compareAtPriceCents = String(compareAtCents);
    subscriptionEl.dataset.subscriptionPriceCents = String(subCents);
  };

  const getFixedPurchasePrices = (subscriptionEl, purchaseType) => {
    const otpCents = parseInt(subscriptionEl.dataset.oneTimePriceCents || '0', 10);
    const subCents = parseInt(subscriptionEl.dataset.subscriptionPriceCents || '0', 10);
    const compareCents = parseInt(subscriptionEl.dataset.compareAtPriceCents || '0', 10);

    if (!otpCents || !subCents) return null;

    const saleCents = purchaseType === 'subscription' ? subCents : otpCents;
    const compareAtCents = resolveCompareAtCents(
      subscriptionEl,
      Math.min(otpCents, subCents),
      compareCents
    );

    return {
      price: Math.round(saleCents / 100),
      compareAtPrice: Math.round(compareAtCents / 100),
    };
  };

  const updateOptionPrice = (label, prices) => {
    const mainPriceEl = label.querySelector('.js-subscribtion__option-price .js-subscribtion__main-price');
    const compareAtEl = label.querySelector('.js-subscribtion__option-price .js-subscribtion__compare-at-price');

    if (mainPriceEl) {
      let priceWrapper = mainPriceEl.querySelector('.product_price');
      if (!priceWrapper) {
        priceWrapper = document.createElement('span');
        priceWrapper.className = 'product_price';
        mainPriceEl.innerHTML = '';
        mainPriceEl.appendChild(priceWrapper);
      }
      priceWrapper.textContent = formatMoney(prices.price);
    }

    if (compareAtEl) {
      let compareWrapper = compareAtEl.querySelector('.product_price');
      if (!compareWrapper) {
        compareWrapper = document.createElement('span');
        compareWrapper.className = 'product_price';
        compareAtEl.innerHTML = '';
        compareAtEl.appendChild(compareWrapper);
      }
      compareWrapper.textContent = formatMoney(prices.compareAtPrice);
      compareAtEl.classList.remove('is-hidden');
    }
  };

  const updatePurchaseTypeCardPrices = (subscriptionEl) => {
    const purchaseTypeRadios = subscriptionEl.querySelectorAll('#purchase-type-fieldset input[name="purchase_type"]');
    if (!purchaseTypeRadios.length) return;

    purchaseTypeRadios.forEach((radio) => {
      const prices = getFixedPurchasePrices(subscriptionEl, radio.value);
      if (!prices) return;

      updateOptionPrice(radio.parentElement, prices);
    });
  };

  const keepCompareAtVisible = (section) => {
    section
      .querySelectorAll(
        '#purchase-type-fieldset .js-subscribtion__compare-at-price, #quantity-fieldset .js-subscribtion__compare-at-price'
      )
      .forEach((element) => {
        element.classList.remove('is-hidden');
      });

    const subscriptionEl = section.querySelector('c-subscription');
    const showInButton = subscriptionEl?.dataset.showCompareAtPriceInButton === 'true';
    const ctaCompareAtSelectors =
      '.c-subscribtion__add-to-cart .js-subscribtion__compare-at-price-wrapper, .c-subscribtion__add-to-cart .js-subscribtion__compare-at-price, .c-subscribtion__add-to-cart .c-subscribtion__price-original';

    section.querySelectorAll(ctaCompareAtSelectors).forEach((element) => {
      element.classList.toggle('is-hidden', !showInButton);
    });
  };

  const syncLpPurchaseTypePrices = (section) => {
    const subscriptionEl = section.querySelector('c-subscription');
    const form = subscriptionEl?.querySelector('.js-subscribtion__subscription-form');
    if (!subscriptionEl || !form) return;

    syncVariantPriceDataset(subscriptionEl, form);
    updatePurchaseTypeCardPrices(subscriptionEl);
    keepCompareAtVisible(section);
  };

  const initLpMainProductForm = (section) => {
    const subscriptionEl = section.querySelector('c-subscription');
    const form = subscriptionEl?.querySelector('.js-subscribtion__subscription-form');
    if (!subscriptionEl || !form || form.dataset.lpCompareAtInit === 'true') return;

    form.dataset.lpCompareAtInit = 'true';

    const scheduleSync = () => {
      queueMicrotask(() => syncLpPurchaseTypePrices(section));
      window.setTimeout(() => syncLpPurchaseTypePrices(section), 0);
    };

    form.addEventListener('change', scheduleSync);
    scheduleSync();
  };

  if (!document.documentElement.dataset.lpCompareAtPriceListener) {
    document.documentElement.dataset.lpCompareAtPriceListener = 'true';
    document.addEventListener('product:price-updated', () => {
      document.querySelectorAll(SECTION_SELECTOR).forEach(syncLpPurchaseTypePrices);
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initLpMainProductForm);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches(SECTION_SELECTOR)) {
      initLpMainProductForm(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
